/**
 * @generated SignedSource<<b813023754a9b145ce165f16a407c601>>
 * @relayHash 59527960279493483dc426741a94e942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { formatRulesQuery } from './formatRulesQuery.graphql';

const node: PreloadableConcreteRequest<formatRulesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39",
    "metadata": {},
    "name": "formatRulesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
